import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { logoutRequest } from "store/state/auth";
import { withRouter } from "react-router-dom";
import SubscriptionServicesAgreement from "./SubscriptionServicesAgreement";
import { acceptAgreements } from "store/state/contacts";
import { getUser } from "store/state/users";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import Logo from "lib/images/loanbossLogoBlack.png";
import { ROUTE_DASHBOARD, ROUTE_BROKER_DASHBOARD, ROUTE_GUEST_LANDING } from "constants/routes";
import { useFlags } from "launchdarkly-react-client-sdk";

const AgreementWrapper = styled.div`
  width: 62vw;
  height: 55vh;
  background: #FFFFFF;
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border-radius: 8px;
  margin: auto;
  overflow-y: scroll;
`;

const HeaderWrapper = styled.div`
  width: 85vw;
  margin: auto;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;

  font-family: Work Sans;
  font-style: normal;
  line-height: 56px;
  color: #000000;

  .welcome {
    font-weight: 500;
    font-size: 48px;
    margin: auto;
  }

  .logo {
    margin: auto;
    width: 577px;
  }

  .txt {
    margin: auto;
    font-size: 24px;
    line-height: 28px;
  }
`;

const ButtonWrapper = styled.div`
  width: 62vw;
  margin: auto;
  text-align: end;
  margin-top: 15px;
`;

const PoliciesAndAgreements = (props) => {
  
  const { authentication } = props;
  
  const [shouldShowSSA, setShouldShowSSA] = useState(true);
  const [hasAcceptedSSA, setHasAcceptedSSA] = useState(false);
  const flags = useFlags();
  const {
    us1999RedirectToBrokerApp: shouldUseNewBrokerFrontend,
    us1304BrokerFrontendUrlEnvironmentVariable: brokerFrontendURL,
  } = flags;
    
  useEffect(() => {
    if (!authentication?.user?.hasAcceptedAgreement || shouldUseNewBrokerFrontend === undefined) {
      return;
    }
    
    const userHasGuestAccess = authentication?.guestAccess === "guest";
    if (userHasGuestAccess){
      props.history.replace(ROUTE_GUEST_LANDING);
    }
    else if (authentication?.user?.prefersBrokerDashboardView) {
      if (shouldUseNewBrokerFrontend) {
        window.location.replace(brokerFrontendURL);
      }
      else {
        props.history.replace(ROUTE_BROKER_DASHBOARD);
      }
    }
    else {
      props.history.replace(ROUTE_DASHBOARD);
    }
  }, [authentication, flags]);
  
  const declineAgreements = () => {
    props.logoutRequest();
  };
  
  return (
    <>
      <HeaderWrapper>
        <div class="welcome">Welcome to</div>
        <img class="logo" src={Logo} id="homeLogo" alt="logo" />
        <div class="txt">Please read through the following policies and agreements to continue to the LoanBoss application.</div>
        <div class="txt">Feel free to reach out to <a href="mailto:support@loanboss.com">support@loanboss.com</a> with any questions.</div>
      </HeaderWrapper>
  
      {shouldShowSSA && <AgreementWrapper>
        <SubscriptionServicesAgreement
          primaryClick={() => { 
            setShouldShowSSA(!shouldShowSSA);
            setHasAcceptedSSA(!hasAcceptedSSA);
          }}
          secondaryClick={() => setShouldShowSSA(!shouldShowSSA)} />
      </AgreementWrapper>}
  
      <ButtonWrapper>
        <SecondaryButton
        style={{marginRight:"15px"}}
          label="Decline"
          onClick={declineAgreements}
          buttonSize={ButtonSizeOptions.smFluid} />
        <PrimaryButton
          label="Accept"
          onClick={() => {
            props.acceptAgreements({ userId: authentication.user.id, callback: () => window.location.reload() });
          }}
          buttonSize={ButtonSizeOptions.smFluid} />
      </ButtonWrapper>
    </>
  );
  
};

const mapStateToProps = ({ users, authentication, contacts }) => ({ users, authentication, contacts });

export default compose(
  withRouter,
  connect(mapStateToProps,
    {
      acceptAgreements,
      getUser,
      logoutRequest
    }),
)(PoliciesAndAgreements);
